<script setup>
import { computed } from 'vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import FormattedContent from './FormattedContent.vue';
import AttachmentChips from 'next/message/chips/AttachmentChips.vue';
import { MESSAGE_TYPES } from '../../constants';
import { useMessageContext } from '../../provider.js';

const { content, attachments, contentAttributes, messageType, translations } =
  useMessageContext();

const spanishTranslation = computed(
  () =>
    translations.value?.es?.trim() ||
    contentAttributes.value?.translations?.es?.trim()
);
const showSpanishTranslation = computed(
  () =>
    messageType.value === MESSAGE_TYPES.INCOMING &&
    spanishTranslation.value &&
    spanishTranslation.value !== content.value?.trim()
);

const isTemplate = computed(() => {
  return messageType.value === MESSAGE_TYPES.TEMPLATE;
});

const isEmpty = computed(() => {
  return !content.value && !attachments.value?.length;
});
</script>

<template>
  <BaseBubble class="px-2.5 py-1.5" data-bubble-name="text">
    <div class="flex flex-col gap-1.5">
      <span v-if="isEmpty" class="text-n-slate-11">
        {{ $t('CONVERSATION.NO_CONTENT') }}
      </span>
      <FormattedContent v-if="content" :content="content" />
      <div
        v-if="showSpanishTranslation"
        class="pt-2 border-t border-n-weak"
      >
        <div class="mb-1 text-xs font-medium text-n-slate-11">
          Traducción al español
        </div>
        <FormattedContent :content="spanishTranslation" />
      </div>
      <AttachmentChips :attachments="attachments" class="gap-2" />
      <template v-if="isTemplate">
        <div
          v-if="contentAttributes.submittedEmail"
          class="px-2 py-1 rounded-lg bg-n-alpha-3"
        >
          {{ contentAttributes.submittedEmail }}
        </div>
      </template>
    </div>
  </BaseBubble>
</template>

<style>
p:last-child {
  margin-bottom: 0;
}
</style>
